// components/dashboard/DashboardHeaderAdmin.jsx
import React from 'react';
import { Menu, X, BellRing, Mail } from 'lucide-react';
import SearchBarAdmin from './searchBarAdmin';

const DashboardHeaderAdmin = ({ isSidebarOpen, setIsSidebarOpen, user }) => {
    return (
        <header className="bg-white shadow-md sticky top-0 z-40">
            <div className="max-w-7xl mx-auto px-4">
                <div className="flex items-center justify-between h-16">
                    <button
                        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
                        className="lg:hidden p-2 rounded-md hover:bg-[#F4F8E9]"
                    >
                        {isSidebarOpen ? (
                            <X className="w-6 h-6 text-[#437011]" />
                        ) : (
                            <Menu className="w-6 h-6 text-[#437011]" />
                        )}
                    </button>

                    <SearchBarAdmin className="hidden md:flex ml-4" />

                    <div className="flex items-center space-x-4">
                        <button className="p-2 rounded-full hover:bg-[#F4F8E9] relative">
                            <BellRing className="w-6 h-6 text-[#437011]" />
                            <span className="absolute top-0 right-0 w-2 h-2 bg-[#FF8A3D] rounded-full"></span>
                        </button>
                        <button className="hidden sm:block p-2 rounded-full hover:bg-[#F4F8E9]">
                            <Mail className="w-6 h-6 text-[#437011]" />
                        </button>
                        <button className="flex items-center">
                            <img
                                src="images/userp.jpg"
                                alt="Profile"
                                className="w-8 h-8 rounded-full border-2 border-[#96B734]"
                            />
                        </button>
                    </div>
                </div>
            </div>
        </header>
    );
};

export default DashboardHeaderAdmin;